// src/lib/cancellation-policies-api.js — #6 (ADR-206) : client admin de l'éditeur
// des 4 politiques d'annulation (FR/EN/ES). Actions requireAdmin du routeur
// beds24-mapping : cancellation_policies_get | cancellation_policies_save.
import { supabase } from '../supabase';

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    Authorization: `Bearer ${session?.access_token || ''}`,
    'Content-Type': 'application/json',
  };
}

async function parseOrThrow(res, fallback) {
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || fallback);
  return json;
}

/** GET → { items: [{ key, default_fr, override:{text_fr,text_en?,text_es?}|null }] } */
export async function fetchCancellationPolicies() {
  const res = await fetch('/api/beds24-mapping?action=cancellation_policies_get', {
    headers: await authHeaders(),
  });
  return parseOrThrow(res, 'Chargement des politiques échoué');
}

/** POST set → { ok, override, warnings? } */
export async function saveCancellationPolicy(key, policy) {
  const res = await fetch('/api/beds24-mapping?action=cancellation_policies_save', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ key, op: 'set', policy }),
  });
  return parseOrThrow(res, 'Enregistrement échoué');
}

/** POST reset → retour au texte par défaut codé. */
export async function resetCancellationPolicy(key) {
  const res = await fetch('/api/beds24-mapping?action=cancellation_policies_save', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ key, op: 'reset' }),
  });
  return parseOrThrow(res, 'Réinitialisation échouée');
}

/**
 * Lot P — crée une politique CUSTOM. La clé est générée CÔTÉ SERVEUR
 * (custom_<slug>_<4hex>). → { ok, key, policy:{label, text_fr} }
 */
export async function createCancellationPolicy(label, text_fr) {
  const res = await fetch('/api/beds24-mapping?action=cancellation_policies_create', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ label, text_fr }),
  });
  return parseOrThrow(res, 'Création échouée');
}

/**
 * Lot P — supprime une politique CUSTOM. Les 4 d'origine → 403 côté serveur.
 * 409 politique_affectee → l'erreur levée porte `code='politique_affectee'` et
 * `logements` (ids encore affectés) pour l'affichage UI — AUCUNE réaffectation
 * automatique (décision Dimitri).
 */
export async function deleteCancellationPolicy(key) {
  const res = await fetch('/api/beds24-mapping?action=cancellation_policies_delete', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ key }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.error || 'Suppression échouée');
    err.code = json?.error || null;
    if (Array.isArray(json?.logements)) err.logements = json.logements;
    throw err;
  }
  return json;
}
